import { ButtonDS, DialogModalDS, TextCapitalized } from "@qivia/ui";
import { Spacer } from "@qivia/ui/src/designSystem/components/Spacer";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { useAppDispatch, useAppSelector } from "../../../../redux/hooks";
import { colors } from "@qivia/ui/src/styles/figmaColors";
import { typographies } from "@qivia/ui/src/styles/figmaTypographies";
import { useNavigate } from "react-router-dom";
import { selectCompany } from "../../homeSlice";
import { ManagerDataDisplayRow } from "../usersAPI";
import { removeCompanyFromCompaniesAccessAsync } from "../usersSlice";
import "../../../../i18n/i18n";

export const RemoveCompanyFromCompaniesAccessModal = (props: {
  isVisible: boolean;
  onCloseModal: () => void;
  manager: ManagerDataDisplayRow;
}) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const company = useAppSelector(selectCompany);

  const removeCompanyFromCompaniesAccessOfUser = useCallback(() => {
    if (!company || !props.manager.uuid) return;
    void dispatch(
      removeCompanyFromCompaniesAccessAsync({
        managerToUpdateUuid: props.manager.uuid,
        companyUuid: company.uuid,
      }),
    );
    props.onCloseModal();
    navigate(`/home/users/management`);
  }, [dispatch, navigate, props, company]);

  return (
    <DialogModalDS
      visible={props.isVisible}
      onClose={() => {
        props.onCloseModal();
      }}
      title={t("users.management.remove.user.modal.title")}
    >
      <StyledModalContainer>
        <TextCapitalized>
          {t("users.management.remove.user.modal.subTitle")}
        </TextCapitalized>
        <Spacer y={3} />
        <StyledButtons>
          <ButtonDS
            text={t("users.management.remove.user.modal.button.cancel")}
            onClick={() => {
              props.onCloseModal();
            }}
            buttonType={"secondary"}
            format={"fill"}
          />
          <Spacer x={1.5} />
          <ButtonDS
            text={t("users.management.remove.user.modal.button.confirm")}
            onClick={removeCompanyFromCompaniesAccessOfUser}
            buttonType={"primary"}
            format={"fill"}
          />
        </StyledButtons>
      </StyledModalContainer>
    </DialogModalDS>
  );
};

const StyledModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
  ${typographies["Body/S"]}
  color: ${colors["colors/text/lightGrey"]};
`;

const StyledButtons = styled.div`
  display: flex;
  width: 100%;
`;
